import { Timer, Users, Truck, ShieldAlert } from "lucide-react";
import { Leadership, Reasons, Closing, Statement } from "./SecurityServiceContent";

export const EVENT_INTRO = (
  <>
    <strong className="block text-[var(--ink)] font-bold text-lg sm:text-xl mb-3">Flawless Events Demand Precision. We Bring the Discipline.</strong>
    Planning a successful corporate conference, high-profile gala, or large-scale community event requires more than just good ideas—it demands absolute operational control, punctual execution, and seamless coordination. At S4s Enterprises Pvt. Ltd., our event management vertical is built on a foundation of military-grade planning and rigorous standards.
  </>
);

const REASONS = [
  { icon: Timer, title: "Disciplined Execution", text: "Meticulous timelines, structured contingencies, and zero-compromise protocols." },
  { icon: Users, title: "Unified Teamwork", text: "From crowd flow, access control, and stage production to guest hospitality, our on-ground crew moves as one cohesive unit." },
  { icon: Truck, title: "Turnkey Event Logistics", text: "Venue management, statutory permissions, premium vendor coordination, and high-standard security setups." },
  { icon: ShieldAlert, title: "Safety & Crisis Preparedness", text: "Robust safety planning and risk assessment designed to handle any dynamic scenario quietly and professionally." },
];

export default function EventManagementContent() {
  return (
    <>
      <Leadership testId="event-leadership" text="Led by a Managing Director with an Ex-Serviceman background, our operational philosophy centers on one core driver: flawless teamwork." />
      <Statement testId="event-promise" text="When you partner with S4s, you don't just hire event coordinators; you deploy a synchronized unit committed to turning complex logistics into effortless experiences." />
      <Reasons testId="event-why-choose" lead="What Sets S4s" accent="Event Management Apart" items={REASONS} />
      <Closing testId="event-closing-cta" lead="Your Vision." accent="Our Mission."
        text="Focus on your guests, your brand, and your milestones. Let S4s Enterprises handle every detail behind the scenes with military precision. Contact S4s Enterprises Pvt. Ltd. today to schedule an event consultation." />
    </>
  );
}
